/**
 * Lightweight visibility when the Sentry client pipeline drops or caps events.
 * Breadcrumbs attach to the next successful event; stage logs help debug filters.
 */

let lastRateLimitBreadcrumbAt = 0;
let lastStageDropLogAt = 0;

export function noteClientSentryRateCapHit(options: {
  addBreadcrumb: (crumb: {
    category: string;
    message: string;
    level: "warning" | "error" | "info";
    data?: Record<string, unknown>;
  }) => void;
  capPerMinute: number;
}): void {
  const now = Date.now();
  if (now - lastRateLimitBreadcrumbAt < 60_000) return;
  lastRateLimitBreadcrumbAt = now;
  options.addBreadcrumb({
    category: "sentry.pipeline",
    message: "client_event_rate_cap_reached",
    level: "warning",
    data: {
      capPerMinute: options.capPerMinute,
      note: "Some events in this minute window were dropped by the client cap.",
    },
  });
}

/** Sampled console line on stage when beforeSend drops an event (debugging filters). */
export function maybeLogStageBeforeSendDrop(options: {
  environment: string;
  reason: string;
  detail?: string;
}): void {
  if (options.environment !== "stage-v2") return;
  const now = Date.now();
  if (now - lastStageDropLogAt < 45_000) return;
  if (Math.random() > 0.04) return;
  lastStageDropLogAt = now;
  console.info("[sentry] beforeSend drop (sampled)", {
    reason: options.reason,
    detail: options.detail?.slice(0, 160),
  });
}
